import { PlaycastKeyDetail, PlaycastKeyboardState } from '@playcastdotio/CoreTypes';
import {
  PlaycastMessage,
  PlaycastMessageKeyboardDown,
  PlaycastMessageKeyboardSetState,
  PlaycastMessageKeyboardUp,
  PlaycastMessageSource,
} from '../types';
import { formatMessage } from './_util/formatMessage';

const target = 'keyboard';

/**
 * @experimental This is an experimental feature and may be changed in the future.
 * You should probably use `keyboard.down` instead.
 */
export const downExperimental = (keyDetail: PlaycastKeyDetail, userAuth?: string): PlaycastMessage<PlaycastMessageKeyboardDown> => {
  const hostId = 'experimental';
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageKeyboardDown = {
    target,
    action: 'down',
    isReply: false,
    message: keyDetail,
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageKeyboardDown>;
};

/**
 * @experimental This is an experimental feature and may be changed in the future.
 * You should probably use `keyboard.up` instead.
 */
export const upExperimental = (keyDetail: PlaycastKeyDetail, userAuth?: string): PlaycastMessage<PlaycastMessageKeyboardUp> => {
  const hostId = 'experimental';
  const messageSource: PlaycastMessageSource = 'host';
  const message: PlaycastMessageKeyboardUp = {
    target,
    action: 'up',
    isReply: false,
    message: keyDetail,
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageKeyboardUp>;
};

export const setState = (
  hostId: string,
  state: PlaycastKeyboardState,
  userAuth?: string,
): PlaycastMessage<PlaycastMessageKeyboardSetState> => {
  const messageSource: PlaycastMessageSource = 'player';
  const message: PlaycastMessageKeyboardSetState = {
    target,
    action: 'setState',
    isReply: false,
    message: state,
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageKeyboardSetState>;
};

export const down = (hostId: string, keyDetail: PlaycastKeyDetail, userAuth?: string): PlaycastMessage<PlaycastMessageKeyboardDown> => {
  const messageSource: PlaycastMessageSource = 'player';
  const message: PlaycastMessageKeyboardDown = {
    target,
    action: 'down',
    isReply: false,
    message: keyDetail,
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageKeyboardDown>;
};

export const up = (hostId: string, keyDetail: PlaycastKeyDetail, userAuth?: string): PlaycastMessage<PlaycastMessageKeyboardUp> => {
  const messageSource: PlaycastMessageSource = 'player';
  const message: PlaycastMessageKeyboardUp = {
    target,
    action: 'up',
    isReply: false,
    message: keyDetail,
  };
  return formatMessage(hostId, messageSource, message, userAuth) as PlaycastMessage<PlaycastMessageKeyboardUp>;
};
